import { createAction } from 'typesafe-actions';
import { AccommodationOfferFloorsToggle } from './types';

const modelName = 'accommodationOfferFloor';

export const toggleFloor = createAction(`${modelName}/TOGGLE_FLOOR`)<AccommodationOfferFloorsToggle>();